module.exports = __webpack_public_path__ + "static/media/white-old-well.b4e2ec95.svg";